module.exports = __webpack_public_path__ + "img/money-cny-box-fill.29da3898.svg";